/* eslint-disable react/prop-types */
import lazyLoadingGIF from '../../../Assets/Images/lazyLoadingGIF.gif'

const LazyLoader = ({ text = 'Loading', width = 100, height = 100 }) => (
  <div data-testid='lazy-loader' style={{ textAlign: 'center', padding: '1rem' }}>
    <img src={lazyLoadingGIF} alt={text} style={{ width, height }} />
    <div>{text}</div>
  </div>
)

export default LazyLoader
